import type { EpgDate } from '~/entities/epg/dates'
import type { Range } from '~/entities/epg/programs'

import { toTimestamp } from '~/entities/epg/dates'

export const epgDateToRange = (
  from: EpgDate,
  behind: number,
  ahead: number
): Range => {
  const moment = toTimestamp(from)
  return [moment - behind, moment + ahead]
}
